export const BiEventsNames = {
  WebFunnelPaymentSuccess: "web__funnel__payment__success",
  WebFunnelPaymentDeclined: "web__funnel__payment__declined",
  WebFunnelPaymentClick: "web__funnel__payment__click",
  WebCalendarClick: "web__calendar__click",
  WebCalendarPageView: "web__calendar__page_view",
  WebCalendarSuccess: "web__calendar__success",
  WebCalendarSkip: "web__calendar__skip",
  WebExperimentTreatment: "web__experiment__treatment",
  WebFunnelClick: "web__funnel__click",
  WebFunnelError: "web__funnel__error",
  WebFunnelAlert: "web__funnel__alert",
  WebFunnelView: "web__funnel__view",
  WebInPageFunnelView: "web__in_page_funnel__view",
  WebOpenSiteCross: "web__open_site__cross",
  WebPageClick: "web__page__click",
  WebPageCtaClick: "web__page__cta_click",
  WebPageView: "web__page__view",
  WebPopupClick: "web__popup__click",
  WebPageLoadCross: "web__page_load__cross",
  WebLeadCreate: "web__lead__create",
  WebMarketingLeadCreate: "web__marketing_lead__create",
  WebLeadUpdate: "web__lead__update",
  WebPageError: "web__page__error",
  WebVitals: "web__vitals",
  OnlineFunnelFullstoryRecordingStarted:
    "online_funnel__fullstory_recording__started",
  WebLeadScoreResult: "web__lead_score__result",
  WebDirectLssQualification: "web__direct_lss__qualification",
  WebVisitorStatusCodeCheck: "web__visitor_status_code__check",
  WebCcAvailabilityCheck: "web__cc_availability__check",
  WebCmnEligibility: "web__cmn__eligibility",
  WebModalAction: "web__modal__action",
  WebFormSubmit: "web__form__submit",
  WebAuthPageView: "web__auth__page_view",
  WebAuthPageClick: "web__auth__page_click",
  WebOtpCodeInvalid: "web__otp_code__invalid",
  WebOtpCodeSuccess: "web__otp_code__success",
  WebAuthWrongCredentials: "web__auth__wrong_credentials",
  WebAuthAttempt: "web__auth__attempt",
  WebAuthAttemptError: "web__auth_attempt__error",
  PcWebView: "pc_web__view",
  PcWebClick: "pc_web__click",
  PcWebManageMeetingView: "pc_web__manage_meeting__view",
  PcWebManageMeetingClick: "pc_web__manage_meeting__click",
  PcWebManageMeetingSuccess: "pc_web__manage_meeting__success",
  PcWebError: "pc_web__error",
  PcWebLssAttorneyDetailsView: "pc_web__lss__attorney_details__view",
  PcLegalPlanView: "pc__legal_plan__view",
  PcLegalPlanBannerView: "pc__legal_plan__banner__view",
  WebLegalPlanMessageSent: "web__legal_plan__message_sent",
  WebLegalPlanChatCompleted: "web__legal_plan__chat_completed",
  WebLegalPlanFunnelDataReceived: "web__legal_plan__funnel_data_received",
  WebCostCalculatorView: "web__cost_calculator__view",
  WebCostCalculatorClick: "web__cost_calculator__click",
  WebCostCalculatorFunnelError: "web__funnel__error",
  WebGeoLocationError: "web__geo_location__error",
  WebCcFunnelView: "web__cc_funnel__view",
  WebCcFunnelClick: "web__cc_funnel__click",
  WebCcLeadCreate: "web__cc_lead__create",
} as const;
